import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useState } from "react";
import { getNetwork, switchNetwork } from "../services/wallets/walletconnect/walletConnectClient";

export function NetworkSwitch() {
  const [net, setNet] = useState(getNetwork());

  const onChange = async (_: any, value: "mainnet" | "testnet" | null) => {
    if (!value) return;
    setNet(value);
    await switchNetwork(value); // disconnect + rebuild connector
  };

  return (
    <ToggleButtonGroup
      exclusive
      value={net}
      onChange={onChange}
      size="small"
    >
      <ToggleButton value="testnet">Testnet</ToggleButton>
      <ToggleButton value="mainnet">Mainnet</ToggleButton>
    </ToggleButtonGroup>
  );
}
